const isValidCnpj = (value: string): boolean => {
  if (!value) return false;

  const cnpj = value.toUpperCase().replace(/[.\-/\s]/g, "");

  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;

  // Mantém a rejeição dos CNPJs numéricos formados por um único algarismo.
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const calculateDigit = (base: string): number => {
    let weight = base.length - 7;

    const sum = base.split("").reduce((total, character) => {
      const characterValue = character.charCodeAt(0) - 48;
      const result = total + characterValue * weight;

      weight -= 1;
      if (weight < 2) weight = 9;

      return result;
    }, 0);

    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };

  const base = cnpj.substring(0, 12);
  const firstDigit = calculateDigit(base);
  const secondDigit = calculateDigit(`${base}${firstDigit}`);

  return cnpj.endsWith(`${firstDigit}${secondDigit}`);
};

export default isValidCnpj;
